const RAG_SYSTEMS = [
  {
    id: 'sobi-trend',
    name: '소비트렌드',
    description: '소비자상담 빅데이터 트렌드 분석 RAG 시스템입니다. 소비 패턴 및 트렌드 데이터를 기반으로 질의응답을 제공합니다.',
    docs: [
      { name: '2023년 4월 소비자상담 빅데이터 트렌드', file: '/files/2023년 4월 소비자상담 빅데이터 트렌드_본보고서.pdf' },
      { name: '2023년 5월 소비자상담 빅데이터 트렌드', file: '/files/2023년 5월 소비자상담 빅데이터 트렌드_본보고서1.pdf' },
      { name: '2023년 6월 소비자상담 빅데이터 트렌드', file: '/files/2023년 6월 소비자상담 빅데이터 트렌드_본보고서.pdf' },
    ],
    url: 'http://218.234.79.197:8088/',
    disabled: false,
  },
  {
    id: 'edu-minwon',
    name: '교육청 민원',
    description: '교육청 민원 처리 RAG 시스템입니다. 교육 관련 민원 데이터를 기반으로 질의응답을 제공합니다.',
    docs: [
      { name: '2022 교육청 민원 예시', file: '/files/2022moeqnaexample.pdf' },
      { name: '2023 교육청 민원 예시', file: '/files/2023moeqnaexample.pdf' },
    ],
    url: '/spm/module/chatLogin.do',
    disabled: false,
  },
  {
    id: 'university',
    name: '대학',
    description: '대학 관련 RAG 시스템입니다. 대학 데이터를 기반으로 질의응답을 제공합니다.',
    docs: [],
    url: 'http://218.234.79.197:8195/',
    disabled: true,
    disabledReason: '준비 중입니다',
  },
];

export default RAG_SYSTEMS;
